import convertNode from "./convertNode";

export default function parseHeader(xmlNode) {
  return {
    type: "paragraph",
    attrs: { class: "header" },
    content: Array.from(xmlNode.children).map(convertNode),
  };
}
